'use strict';

var React = require('react');

var SvgManagedStoreMajor = function SvgManagedStoreMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m1.623 2.253-.609 3.583c-.104.61.376 1.164 1.007 1.164h.91c.58 0 1.11-.321 1.37-.83l.596-1.17.597 1.17c.26.509.79.83 1.37.83h1.169c.58 0 1.11-.321 1.369-.83l.598-1.17.597 1.17c.26.509.79.83 1.37.83h1.169c.58 0 1.11-.321 1.369-.83l.597-1.17.598 1.17c.259.509.789.83 1.369.83h.91c.63 0 1.11-.555 1.007-1.164l-.61-3.583a1.522 1.522 0 0 0-1.509-1.253h-13.733c-.748 0-1.387.53-1.51 1.253zm12.084 7.04a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414l1.293 1.293 3.293-3.293a1 1 0 0 1 1.414 0zm-9.707-.293h-2v8.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-8.5h-2v8h-12v-8z"
  }));
};

exports.SvgManagedStoreMajor = SvgManagedStoreMajor;
